export default {
  schedulingPlanApi: {
    // 验证当前账号是否能上线
    checkLawyerPlan: 'api/lawyerPlanMgr/checkLawyerPlan',
    // 修改律师状态
    changeLawyerStatus: 'api/lawyerPlanMgr/changeLawyerStatus',
    // 获取律师所有班次类型的上下线状态
    getLawyerAllStatus: 'api/lawyerPlanMgr/getLawyerAllStatus',

    getSchedulingPlanStatus: 'api/schedulingPlanBase/getSchedulingPlanStatus',
    getSchedulingGroupStatus: 'api/schedulingPlanBase/getSchedulingGroupStatus',
    getPlanTags: 'api/schedulingPlanBase/getPlanTags',
    createTag: 'api/schedulingPlanBase/createTag',
    getLawyerTags: 'api/schedulingPlanBase/getLawyerTags',
    getLawyerByType: 'api/schedulingPlanBase/getLawyerByType',
    // 获取规则列表
    getSchedulingPlanRules: 'api/schedulingRuleMgr/getSchedulingPlanRules',
    //获取配置规则
    getAllConfigCacheByType: 'api/schedulingRuleMgr/getAllConfigCacheByType',
    // 修改规则状态
    changeRuleStatus: 'api/schedulingRuleMgr/changeRuleStatus',
    // 删除规则
    delRules: 'api/schedulingRuleMgr/delRules',
    // 添加规则
    saveRule: 'api/schedulingRuleMgr/saveRule',
    // 修改规则
    updateRule: 'api/schedulingRuleMgr/updateRule',

    groupApi: {
      getGroupDraftPageList: 'api/schedulingGroupMgr/getGroupDraftPageList',
      getGroupEffectivePageList: 'api/schedulingGroupMgr/getGroupEffectivePageList',
      // 生成班次信息
      generatePlans: 'api/schedulingGroupMgr/generatePlans',
      // 创建班组生成班次信息
      createGroup: 'api/schedulingGroupMgr/createGroup',
      // 更新班次信息
      updateGroup: 'api/schedulingGroupMgr/updateGroup',
      // 删除/关闭班组
      canceledGroup: 'api/schedulingGroupMgr/canceledGroup',
      // 班组基本信息
      groupDetail: 'api/schedulingGroupMgr/groupDetail',
      // 班组全量信息
      groupFullDetail: 'api/schedulingGroupMgr/groupFullDetail',
      getGroupPlanPublishPageList: 'api/schedulingGroupMgr/getGroupPlanPublishPageList'
    },

    // 班次草稿列表
    getPlanDraftPageList: 'api/schedulingPlanMgr/getPlanDraftPageList',
    // 删除｜关闭班次
    canceledPlan: 'api/schedulingPlanMgr/canceledPlan',
    // 发布班次
    publishPlan: 'api/schedulingPlanMgr/publishPlan',
    // 批量发布班次
    batchPublishPlan: 'api/schedulingPlanMgr/batchPublishPlan',
    publishPlanByData: 'api/schedulingPlanMgr/publishPlanByData',
    //修改抢班人数
    changeGrabbingNum: 'api/schedulingPlanMgr/changeGrabbingNum',
    // 班次基础数据信息
    planDetail: 'api/schedulingPlanMgr/planDetail',
    // 班次全量数据信息
    planFullDetail: 'api/schedulingPlanMgr/planFullDetail',
    // 律师-班次预约列表
    getScheduleAppointment: 'api/schedulingPlanMgr/getScheduleAppointment',
    // 律师抢单
    grabbingPlan: 'api/schedulingPlanMgr/grabbingPlan',
    // 取消预约
    cancelReservationPlan: 'api/schedulingPlanMgr/cancelReservationPlan',
    // 班次发布列表
    getPlanPublishPageList: 'api/schedulingPlanMgr/getPlanPublishPageList',
    // 班次的律师列表
    planLawyers: 'api/schedulingPlanMgr/planLawyers',
    // 律师取消班次记录
    planLawyersCancelLogs: 'api/schedulingPlanMgr/planLawyersCancelLogs',
    // 删除指定班次的律师
    delLawyerMapping: 'api/schedulingPlanMgr/delLawyerMapping',
    // 班次可选择律师列表
    planLawyerList: 'api/schedulingPlanMgr/planLawyerList',
    // 添加班次律师信息
    savePlanLawyers: 'api/schedulingPlanMgr/savePlanLawyers',

    getPlans: '/api/schedulingPlanCalendar/getPlans'
  }
}